/**
 * window.FlexoBridge — SignalR interop for the Unity WebGL build.
 *
 * ============================================================================================
 * V3 b-libs(2): THIS IS NO LONGER AN IMPLEMENTATION. It is the dating tenant's PROFILE of the
 * shared one (`@gamedate/core-unity`), kept at this path so nothing that imports it has to move.
 * ============================================================================================
 *
 * The 415 lines that used to live here — the Unity↔RoomHub translation table, the echo and room
 * filters, the reconnect wiring — are now `libs/core-unity/src/flexoBridge.ts`, which the school
 * product has been running on since iteration 1. There is one body of code again.
 *
 * WHY THIS WAS SAFE TO DO, given `web-app` has no test suite.
 * Iteration 1's oracle was the byte-identity of this bundle, and that oracle is useless for a
 * change whose whole purpose is to move code. It was replaced FIRST, then the swap was made:
 *
 *   `libs/tests/bridge-conformance.test.ts` runs one behavioural suite — connect, join, relay in
 *   both directions, reconnect, disconnect — against BOTH implementations. It was written against
 *   the fork that was live here and passed against it before a line of this file changed, so its
 *   assertions describe the SHIPPED product's real behaviour rather than the library's intentions.
 *   The shared bridge then passed the same suite unmodified. Five deliberate mutations of the
 *   shared bridge (dropped echo filter, unsubscribed DungeonMaster, altered reconnect ladder,
 *   dropped the top-level `rotY` the server persists from, a silently flipped reconnect default)
 *   were each caught, so the suite discriminates rather than merely passing.
 *
 * WHAT DELIBERATELY DID NOT CHANGE. The shared package's defaults ARE this file's old behaviour,
 * including one thing that is arguably a bug: `rejoinOnReconnect` is FALSE here. SignalR groups do
 * not survive a reconnect, and this bridge holds `currentRoomId` across one without re-joining, so
 * a dating player who briefly drops stops receiving room traffic. school-app sets the flag and
 * fixes it for itself. Turning it on for dating is a real behavioural change that wants a
 * two-client QA pass; it is named in the notes and pinned by a conformance test asserting the
 * current behaviour, NOT smuggled in under an extraction.
 */
import { configureFlexoBridge } from '@gamedate/core-unity';

// The dating profile, stated explicitly rather than relied on as a default — a host that says
// nothing is a host nobody can grep for.
configureFlexoBridge({
  /** The dating bundle's bearer-token key. school-app uses `qa.studentToken`. */
  tokenKey: 'gamedate_token',
  /** See the note above: this is the pre-existing behaviour, held deliberately. */
  rejoinOnReconnect: false,
});

export { flexoBridge, installFlexoBridge } from '@gamedate/core-unity';
export type { FlexoPositionUpdate, SocialEventEnvelope } from '@gamedate/core-unity';
